module.exports = __webpack_public_path__ + "static/media/img-emandamento-sanpaolo-jun23-4.ea204689.jpg";